import { TAction } from "../../base/types/redux";
import ReducerRegistry from "../../base/redux/ReducerRegistry";
// import { EkycOptionsType, EkycFormRequest } from "../utils/types";
import { ACTION_TYPES } from "./actionTypes";

const initState: any = {
  ekycOptions: {},
  getCreateEkycState: {
    isFetching: false,
    isSuccess: null,
    data: null
  },
  stockCodeOptions: [],
};

const reducer = (state = initState, action: TAction) => {
  switch (action.type) {
    case ACTION_TYPES.SET_EKYC_OPTIONS: {
      return {
        ...state,
        ekycOptions: action.response.data,
      };
    }
    case ACTION_TYPES.SET_CREATE_EKYC_STATE: {
      return {
        ...state,
        getCreateEkycState: action.response,
      };
    }
    case ACTION_TYPES.SET_STOCK_CODE_OPTIONS: {
      return {
        ...state,
        stockCodeOptions: action.response.data,
      };
    }
    default:
      return state;
  }
};

ReducerRegistry.register("ekyc", reducer);
